export default __webpack_public_path__ + "pypi/stlite_lib-0.1.0-py3-none-any.whl";